export default __webpack_public_path__ + "static/media/Rectangle 137038.599033ca.png";